import { HeaderCell } from '../../../../components/table/HeaderCell';
import { TableColumn } from './constants';

export const HeaderRow = () => (
  <>
    <HeaderCell columnId={TableColumn.messageType} isSortable label="Message type" />
    <HeaderCell columnId={TableColumn.subscriptionPolicy} isSortable label="Subscription policy" />
    <HeaderCell columnId={TableColumn.status} isSortable label="Subscribed?" />
    <HeaderCell columnId={TableColumn.subscriptionAction} label="" />
  </>
);
